import ContentSection from './components/ContentSection';
import { TermsOfServiceWrapper } from './styles';

const TermsOfService = () => {
  return (
    <TermsOfServiceWrapper>
      <ContentSection />
    </TermsOfServiceWrapper>
  );
};

export default TermsOfService;
